import { render, staticRenderFns } from "./NewChatExpandableField.vue?vue&type=template&id=1bce72ea"
import script from "./NewChatExpandableField.vue?vue&type=script&lang=js"
export * from "./NewChatExpandableField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports